<template>
  <div v-if="pageContent" v-editable="pageContent">
    <ContentBlockList
      :blocks="pageContent.body"
      :user-signed-in="userStatus.userSignedIn"
    />
  </div>
</template>

<script>
import { mapState } from "vuex"

import ContentBlockList from "@soenergy/frontend-library/src/components/ContentBlockList"
import cmsPreviewMixin from "@soenergy/frontend-library/src/mixins/cmsPreviewMixin"

import story from "soenergy-cms-loader!?path=account/home-cover"

export default {
  name: "HomeCover",
  components: {
    ContentBlockList,
  },
  mixins: [cmsPreviewMixin({ story })],
  computed: {
    ...mapState({
      userStatus: (state) => state.userStatus.userStatus,
    }),
  },
}
</script>
